import { jsx as _jsx } from "react/jsx-runtime";
import { StyledHeadline } from './Headline.styles';
export const Headline = ({ align, children, className, renderAs, size })=>/*#__PURE__*/ _jsx(StyledHeadline, {
        $align: align,
        $size: size,
        as: renderAs,
        className: className,
        children: children
    });

//# sourceMappingURL=Headline.js.map